"use client";

import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "./cn";

/** Native select, styled to match Input with a custom chevron. */
export const Select = forwardRef<
  HTMLSelectElement,
  SelectHTMLAttributes<HTMLSelectElement>
>(function Select({ className, children, ...props }, ref) {
  return (
    <div className="relative inline-flex w-full">
      <select
        ref={ref}
        className={cn(
          "w-full h-9 pl-3 pr-9 rounded-control text-sm appearance-none cursor-pointer",
          "bg-surface text-foreground border border-border",
          "focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <svg
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <path d="M6 8l4 4 4-4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
});
